/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { typography } from '@/styles/Intertoys/type';
import { ThemeManifestTheme } from '@/styles/manifest';
import { fonts } from '@/styles/Intertoys/fonts';
import { palette } from '@/styles/Intertoys/palette';
import { Link } from '@/styles/Intertoys/Link';
import { Button } from '@/styles/Intertoys/Button';
import { TextField } from '@/styles/Intertoys/TextField';
import { shape } from '@/styles/Intertoys/shape';
import { Checkbox } from '@/styles/Intertoys/Checkbox';
import { dimensions } from '@/styles/Intertoys/dimensions';
import { CssBaseline } from '@/styles/Intertoys/CssBaseline';
import { breakpoints } from '@/styles/Intertoys/breakpoints';
import { zIndex } from '@/styles/Intertoys/zIndex';
import { RadioA11y as Radio } from '@/styles/Intertoys/Radio';

export const IntertoysTheme: ThemeManifestTheme = {
	inheritFrom: 'Default',
	components: [
		fonts,
		typography,
		palette,
		Link,
		Button,
		TextField,
		shape,
		Checkbox,
		dimensions,
		CssBaseline,
		breakpoints,
		zIndex,
		Radio
	],
};
